import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import ContactHero from './components/ContactHero';
import ContactMethods from './components/ContactMethods';
import ContactForm from './components/ContactForm';
import LocationMap from './components/LocationMap';
import SocialMedia from './components/SocialMedia';
import FAQ from './components/FAQ';

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <main>
        <ContactHero />
        <ContactMethods />
        <ContactForm />
        <LocationMap />
        <SocialMedia />
        <FAQ />
      </main>

      <Footer />
    </div>
  );
};

export default Contact;